<template>
  <div v-if="fontsReady">
    <Header v-if="!isStandalone" />
    <Content :standalone="isStandalone" />
    <Footer v-if="!isStandalone" />
  </div>
  <div v-else class="flex justify-center items-center h-screen bg-white">
    <p class="text-lg font-medium">Getting started...</p>
  </div>
</template>

<script>
import Header from "./Header.vue";
import Content from "./Content.vue";
import Footer from "./Footer.vue";

export default {
  components: { Header, Content, Footer },
  data() {
    return {
      fontsReady: false,
    };
  },
  computed: {
    isStandalone() {
      return this.$route?.meta?.standalone === true;
    },
  },
  async mounted() {
    try {
      await document.fonts.ready;
    } finally {
      this.fontsReady = true;
    }
  },
};
</script>
